import { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../components/AuthContext'
import axios from 'axios'
import { useNavigate, useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'

// 1.連 discord
// 2.錯誤訊息
// 3.isLoading
// 4. .finally
// 5. post/get
// 接收參數 1.子URL 2.requestBody Header(應該都一樣) 3.錯誤訊息
export function useAPI({ path, requestBody, msg, initData, dependencies }) {
  const {
    currentUser,
    setCurrentUser,
    BaseUrl,
    setIsLoading,
    popUpToast,
    sendDiscordNotification,
  } = useContext(AuthContext)
  const [fetchData, setFetchData] = useState(initData)
  const location = useLocation()
  const navigate = useNavigate()
  const [counter, setCounter] = useState(0)
  // const [locationPath, setLocationPath] = useState('/')

  //   尚無資料
  const userNoData = Object.keys(fetchData).reduce((accumulator, key) => {
    return { ...accumulator, [key]: '尚無資料' }
  }, {})

  useEffect(() => {
    if (counter > 0) {
      setIsLoading(true)
    } else {
      setIsLoading(false)
    }
  }, [counter])

  // useEffect(() => {
  //   console.log('location.pathname', location.pathname)
  //   if (locationPath !== location.pathname) {
  //     setCounter(0)
  //     const newLocationPath = location.pathname
  //     setLocationPath(newLocationPath)
  //   }
  // }, [locationPath])

  useEffect(() => {
    if (!Cookies.get('tk')) {
      // console.log('location.pathname', location.pathname)
      popUpToast('網頁已逾時，請重新登錄')
      Cookies.remove('tk')
      setCurrentUser({
        inc_id: '',
        tk: '',
        kol_id: '',
        kol_name: '',
        lv: 1,
        inc_name: '',
        inc_icon: '',
        isLocked: false,
      })
      navigate('/')
      // if (location.pathname === '/') {
      //   popUpToast('網頁已逾時，請重新登錄')
      //   navigate('/fans')

      //   return
      // } else {
      //   popUpToast('網頁已逾時，請重新登錄')
      //   navigate('/')

      //   return
      // }
    } else {
      const getCurrentUser = JSON.parse(Cookies.get('tk'))

      if (Object.values(requestBody)[0] !== null) {
        setCounter(counter + 1)
        axios
          .post(BaseUrl + path, requestBody, {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
              tk: currentUser.tk || getCurrentUser.tk,
            },
          })
          .then((res) => {
            // console.log(`useAPI ${path}`, res.data)
            if (res.data.code === '0005') {
              // 尚無資料
              setFetchData(userNoData)
            } else if (res.data.code === '1000') {
              popUpToast('網頁已逾時，請重新登錄')
              Cookies.remove('tk')
              setCurrentUser({
                inc_id: '',
                tk: '',
                kol_id: '',
                kol_name: '',
                lv: 1,
                inc_name: '',
                inc_icon: '',
                isLocked: false,
              })
              navigate('/')
              // navigate(0)
              // Logout
            } else {
              setFetchData(res.data)
            }
          })
          .catch((e) => {
            popUpToast('伺服器忙碌中，請稍後再試')
            Cookies.remove('tk')
            setCurrentUser({
              inc_id: '',
              tk: '',
              kol_id: '',
              kol_name: '',
              lv: 1,
              inc_name: '',
              inc_icon: '',
              isLocked: false,
            })
            navigate('/')
            console.log(e)
            sendDiscordNotification(
              `${msg} \n Error: ${e} \n path: ${path} \n requestBody: ${JSON.stringify(
                requestBody
              )}`
            )
          })
          .finally(() => {
            setCounter(counter - 1)
          })
      }
    }
  }, dependencies)

  return {
    fetchData,
  }
}
